<template>
	<div class="my-account">
		<div class="header-menu va-row">
			<div class="va-row">
				<div class="flex container-ddh-menu xs12 with-bottom va-row">
					<div class="flex xs12 no-padding">
						<h1>Livros</h1>
					</div>
				</div>
			</div>
			<div class="clearfix"></div>
		</div>

		<div class="container-dhh va-row">
			<BooksList :books="list.products || []" />
		</div>
	</div>
</template>

<script>
	import BooksList from "@/components/master/BookList.vue";
	import { mask } from "vue-the-mask";
	import { mapGetters } from "vuex";

	const axios = require("axios");

	export default {
		name: "peoples",
		directives: { mask },
		components: {
			BooksList
		},
		computed: {
			...mapGetters({
				managerCredential: "managerCredential",
			}),
			filteredList() {
				let self = this;
				if (this.list.products) {
					return this.list.products.filter((book) => {
						return book.name
							.toLowerCase()
							.includes(self.searchProducts.toLowerCase());
					});
				}

				return [];
			},
		},
		mounted() {
			const self = this;

			let config = {
				headers: {
					Authorization: "Bearer " + this.managerCredential.token,
				},
			};

			axios
				.get(process.env.VUE_APP_ROOT_API + "/products", config)
				.then((response) => {
					self.list = response.data.data;
				})
				.catch((e) => {
					this.errors.push(e);
				});
		},
		data() {
			return {
				list: [],
				searchProducts: "",
			};
		},
		methods: {},
	};
</script>
<style lang="scss" scoped>
	.container {
		padding: 20px;
	}
</style>
